import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";
import { logError } from "../helpers/utils";
import { getInitialData } from "./InitialDataSlice";

export const getLanguage = createAsyncThunk(
  "LanguageSlice/getLanguage",
  async (data, { rejectWithValue, getState }) => {
    try {
      // Skip if already loaded
      const state = getState();
      if (state.language.language.length > 0) {
        return null;
      }
      const response = await axios.get(
        `${process.env.REACT_APP_LOCAL_API}/languages`
      );
      return response.data.data.Languages;
    } catch (error) {
      logError(error, "LanguageSlice/getLanguage");
      return rejectWithValue(error.response.data);
    }
  }
);

// Use language from DB: match by code or language name (case-insensitive)
const processLanguages = (state, languages) => {
  if (!languages) return;
  state.language = languages;
  languages.forEach((lan) => {
    const isEnglish =
      (lan.code && String(lan.code).toLowerCase() === "en") ||
      (lan.language && String(lan.language).toLowerCase() === "english");
    if (isEnglish) {
      state.englishId = lan._id;
    }
  });
};

export const LanguageSlice = createSlice({
  name: "language",
  initialState: {
    language: [],
    selLanguageId: "",
    englishId: "",
    isEnglish: true,
  },
  reducers: {
    setLanguageId: (state, action) => {
      state.selLanguageId = action.payload;
      if (state.englishId === state.selLanguageId) {
        state.isEnglish = true;
      } else {
        state.isEnglish = false;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getLanguage.fulfilled, (state, action) => {
        if (action.payload) {
          processLanguages(state, action.payload);
        }
      })
      .addCase(getLanguage.rejected, (state, action) => {
        toast.error(action.payload);
      })
      // Listen for initial data load
      .addCase(getInitialData.fulfilled, (state, action) => {
        if (action.payload?.Languages) {
          processLanguages(state, action.payload.Languages);
        }
      });
  },
});
export const { setLanguageId } = LanguageSlice.actions;

export default LanguageSlice.reducer;
